import { useContext } from 'react';
import { CanvasesContext } from '../store';

export function useTemplate() {
	const { state: canvasState } = useContext(CanvasesContext);
	const { template } = canvasState;

	return { template };
}
